import { css } from 'styled-components';
var reducedMotion = css(["@media (prefers-reduced-motion:reduce){animation:none;}"]);
export default reducedMotion;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/animation/primitives/reduceMotion/index.js
// module id = 1766
// module chunks = 12